import { render, staticRenderFns } from "./ClassCards.vue?vue&type=template&id=5d38cfd8&scoped=true"
import script from "./ClassCards.vue?vue&type=script&lang=js"
export * from "./ClassCards.vue?vue&type=script&lang=js"
import style0 from "./ClassCards.vue?vue&type=style&index=0&id=5d38cfd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38cfd8",
  null
  
)

export default component.exports